module.exports = __webpack_public_path__ + "img/prize2.44f1420.png";